export default __webpack_public_path__ + "static/media/shopify_coins.02fc4dcf.png";